module.exports = __webpack_public_path__ + "static/media/logo.da0084f0.png";